import React, {useMemo} from "react";
import classNames from "classnames";
import {formatDMY} from "@/shared/lib/date";
import {useCarousel} from "@/shared/hooks/article/useArticleCarousel";
import Link from "@/Layouts/Link";
import {Svg} from "@/shared/ui/Svg";
import Picture from "@/Components/Picture";
import '@/Scss/Site/Main/articles.scss';

const BlogCarousel = ({data = []}) => {
    const options = useMemo(() => ({
        loop: data.length > 1,
        align: 'start'
    }), [data.length]);

    const {
        carouselRef,
        scrollTo,
        next,
        prev,
        selected,
        snaps
    } = useCarousel(options);

    if (data.length === 0) return null;

    return (
        <div className={`embla`}>
            <div ref={carouselRef} className={`embla__viewport`}>
                <div className={`embla__container`}>
                    {data.map((el, i) => {
                        return <Link key={el.id} href={`/blog/${el.url}`} className={`embla__slide`}>
                            <Picture src={el.imgPreview} alt={el.h1} imageClassName={`increase`} />
                            <div className={`embla__slideContent`}>
                                <p className={`embla__slideContentCategory`}>{el.category}</p>
                                <p className={`embla__slideContentTitle`}>{el.h1}</p>
                                <p className={`embla__slideContentDate`}>
                                    {formatDMY(el.published_at)}
                                </p>
                            </div>
                        </Link>
                    })}
                </div>
            </div>
            {data.length > 1 && (
                <div className={`embla__controls`}>
                    <div className={`embla__dots`}>
                        {snaps.map((_, index) => (
                            <div
                                key={`dot-${index}`}
                                className={classNames('embla__dot', {
                                    'embla__dot--selected': index === selected,
                                })}
                                onClick={() => scrollTo(index)}
                            >
                            </div>
                        ))}
                    </div>
                    <div className={`embla__buttons`}>
                        <div className={`embla__prev`} onClick={prev}>
                            <Svg id={`arrowLeft`} className={`svg--arrow`} />
                        </div>
                        <div className={`embla__next`} onClick={next}>
                            <Svg id={`arrowRight`} className={`svg--arrow`} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default BlogCarousel;
